export default __webpack_public_path__ + "static/media/blue.5c643d97.png";